import { trigger, state, style, animate, transition, query, stagger } from '@angular/animations';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-initial',
  templateUrl: './initial.component.html',
  styleUrls: ['./initial.component.scss'],
  animations: [
    trigger('fadeIn', [transition(':enter', [style({ opacity: 0 }), animate('1.5s 1000ms ease-in-out', style({ opacity: 1 }))])]),
    trigger('slideIn', [transition(':enter', [style({ transform: 'translateX(-100%)' }), animate('1.5s 1000ms ease-in-out', style({ transform: 'translateX(0)' }))])]),
    trigger('staggeredFadeIn', [transition(':enter', [query(':enter', [style({ opacity: 0 }), stagger(300, [animate('1s ease-in', style({ opacity: 1 }))])])])])
  ]
})
export class InitialComponent implements OnInit {
  constructor(private router: Router) {}

  ngOnInit(): void {
    setTimeout(() => {
      this.router.navigate(['./auth/signin']);
    }, 4000);
  }
}
